"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const cache = {};
const useFetchSvg = (url) => {
    const [loadedSvg, setLoadedSvg] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        if (!url) {
            return;
        }
        const fetchData = () => {
            if (cache[url]) {
                setLoadedSvg(cache[url]);
            }
            else {
                fetch(url)
                    .then(response => response.text())
                    .then(data => {
                    cache[url] = data;
                    setLoadedSvg(data);
                });
            }
        };
        fetchData();
    }, [url]);
    return loadedSvg;
};
exports.default = useFetchSvg;
